<div
  class="rv-rows small"
  *ngLet="{
    sub: filterChangeHandler | async,
    operatorOptions: operatorOptions | async,
    selectedOperator: selectedOperator | async,
    showDropdown: showDropdown | async,
    options: options | async,
    optionsLoadable: optionsLoadable | async,
    optionsLoader: optionsLoader | async,
    selectedOptionIds: filterIds | async
  } as vm"
>
  <select-dropdown
    [options]="vm.operatorOptions"
    [selectedOptionId]="vm.selectedOperator"
    (selectedOptionIdChange)="selectedOperatorChange.next($event)"
  ></select-dropdown>
  <tree-multi-select-dropdown
    *ngIf="vm.showDropdown"
    [placeholder]="'Select...'"
    [options]="vm.options"
    [filterable]="true"
    [exact]="true"
    [selectedOptions]="vm.selectedOptionIds"
    (selectedOptionsChange)="selectedOptionIdsChange.next($event)"
  ></tree-multi-select-dropdown>
</div>
